export default __webpack_public_path__ + "static/media/image_uploader.278907aa.svg";